import axios from 'axios';
import ApiClient from './ApiClient';

class TicketLogsAPI extends ApiClient {
  constructor() {
    super('ticket_logs', { accountScoped: true });
  }

  getLogs({ ticketId, page = 1, perPage = 20, eventType = null }) {
    const params = {
      ticket_id: ticketId, // Agora ticket_id é um parâmetro
      page,
      per_page: perPage,
    };

    if (eventType) {
      params.event_type = eventType;
    }

    return axios.get(this.url, { params });
  }

  getLog({ ticketId, logId }) {
    return axios.get(`${this.url}/${logId}`);
  }
}

export default new TicketLogsAPI();
